var utils = require('../../utils')
import AppHeader from '../AppHeader'

export default {
  name: 'shop-history-edit',
  created () {
    var today = new Date()
    today.setMonth(today.getMonth() + 2)
    this.afterTwoMonth = new Date(today.getFullYear(), today.getMonth(), 1)

    this.search()
  },
  data () {
    return {
      canValidate: true,
      userImage: null,
      uploadFlg: false,
      user_name: null,
      afterTwoMonth: null,
      user: {
        user_name: null,
        user_name_furigana: null,
        user_firstname: null,
        user_firstname_furigana: null,
        user_sex: null,
        user_birthday_format: null,
        user_age: null
      },
      change: {
        user_id: null,
        shop_id_before: null,
        shop_id_after: null,
        shop_name_before: null,
        shop_name_after: null,
        change_day: null
      }
    }
  },
  computed: {
    userDetail: function() {
      return this.$store.getters.userDetailEdit
    },
    shops: function() {
      return this.$store.getters.userDetailshops
    },
    validation: function() {
      var v = {
        shop_id_after: !!this.change.shop_id_after,
        change_day: !!this.change.change_day,
        change_day_range: this.change.change_day < this.afterTwoMonth,

        not_input: !!this.change.shop_id_after &&
                   this.change.change_day < this.afterTwoMonth &&
                   !!this.change.change_day
      }
      if (!this.canValidate) {
        Object.keys(v).forEach(key => { v[key] = true; });
      }
      return v
    },
    isValid () {
      var validation = this.validation
      return Object.keys(validation).every(function (key) {
        return validation[key]
      })
    },
    notify () {
      return this.$store.getters.shopHistoryNotify
    },
    loading () {
      return this.$store.getters.apiLoading
    },
    authToken () {
      return window.localStorage.getItem('access_token')
    },
    timeStamp () {
      var d = new Date()
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate()
      var hour = (d.getHours() < 10) ? '0' + d.getHours()   : d.getHours()
      var min = (d.getMinutes() < 10) ? '0' + d.getMinutes() : d.getMinutes()
      var sec = (d.getSeconds() < 10) ? '0' + d.getSeconds() : d.getSeconds()
      return year + '' + month + '' + day + '' + hour + '' + min + '' + sec
    }
  },
  components: {
    AppHeader
  },
  methods: {
    goUserLists: function () {
      this.$router.push({ path: '/users', query: { type: this.$router.currentRoute.query.type}})
    },
    goShopLists: function () {
      utils.backClear()
      this.$router.push({ path: '/shops', query: { type: this.$router.currentRoute.query.type}})
    },
    search: function () {
      var data = {}
      var self = this
      var callback = function () {
        self.user.user_name = self.userDetail.attributes['user-name']
        self.user.user_firstname = self.userDetail.attributes['user-firstname']
        self.user.user_name_furigana = self.userDetail.attributes['user-name-furigana']
        self.user.user_firstname_furigana = self.userDetail.attributes['user-firstname-furigana']
        self.user.user_sex = self.userDetail.attributes['sex']
        self.user.user_birthday_format = self.userDetail.attributes['user-birthday-format']
        self.user.user_age = self.userDetail.attributes['age-format']

        self.change.shop_name_before = self.userDetail.attributes['shop-name']

        if (self.userDetail.attributes['user-avartar'] != null) {
          self.userImage = self.userDetail.attributes['avartar-path'] + '?token=' + self.authToken + "&timestamp=" + self.timeStamp
        }
        var workIndex = 0
        for (var i=0; i < self.shops.length; i++) {
          if (self.shops[i].id == self.userDetail.attributes['shop-id']) {
            workIndex = i
            break
          }
        }
        self.shops.splice( workIndex, 1)
      }

      this.$store.dispatch('USER_EDIT',  { id: this.$route.params.id, data: data, callback: callback })
    },
    onClickCancel: function () {
      this.$router.push({ path: '/userhistory/' + this.$route.params.id })
    },
    onClickSave: function () {
      var data = {}
      var self = this
      self.canValidate = true
      if (this.isValid) {
        this.change.shop_id_before = this.userDetail.attributes['shop-id']
        this.change.change_day = this.change.change_day.getFullYear() + '-' + ("0" + (this.change.change_day.getMonth() + 1)).slice(-2) + '-' + ("0" + this.change.change_day.getDate()).slice(-2)
        self.change.user_id = self.$route.params.id
        data = self.change
        this.$store.dispatch('SHOPHISTORY_CREATE', { data: data, callback: this.onSaved })
      } else {
        console.log("need edit");
      }
    },
    onSaved: function (result) {
      this.$router.push('/users/' + this.$route.params.id)
    },
    selectedShops: function() {
      var self = this
      for(var i=0; i < self.$store.getters.userDetailshops.length; i++){
        var shop = self.$store.getters.userDetailshops[i]
        if (shop.id == self.change.shop_id_after) {
          self.change.shop_name_after = shop.attributes['shop-name']
          break;
        }
      }
    },
    /** 画像押下 */
    onClickImageModalShow: function () {
      var button = document.getElementById('imageModalButton')
      var img    = document.getElementById('imageModalImg')
      var text   = document.getElementById('imageModalText')
      img.src = this.userImage
      text.textContent = ''
      button.click() // モーダル表示 イベント発火
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/scripts/shop-history-edit.js